module.exports = __webpack_public_path__ + "media/images/introduction-button-img-e24d66435dc8bb1806287d6116c29ef2.png";